import Dropdown from 'Components/ContractGenerator/layouts/Dropdown';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import ErrorMessage from 'ViatoUi/Shared/Feedback/ErrorMessage/ErrorMessage';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';

import Type from './Type';
import Value from './Value';

const Setting = ({ label, option, optionId, productId, type }) => {
	const dispatch = useDispatch();
	const fieldInfo = useSelector(contractGeneratorSelectors.getDiscountFieldInfo);

	useEffect(() => {
		dispatch(
			contractGeneratorOperations.setDiscountDataToSubmit({
				[type]: {
					[productId]: {
						[optionId]: option
					}
				}
			})
		);
	}, []);

	return (
		<>
			<Dropdown label={label} fullwidth>
				<FlexBox>
					<Value isSetupFee={false} label={label} option={option} optionId={optionId} productId={productId} type={type} />
					<Spacer width='s' />
					<Type isSetupFee={false} option={option} optionId={optionId} productId={productId} type={type} />
				</FlexBox>
				{get(fieldInfo, `${type}.${productId}.${optionId}.discount.value.isValid`, true) === false && (
					<ErrorMessage errorMessages={get(fieldInfo, `${type}.${productId}.${optionId}.discount.value.errorMessages`, [])} />
				)}

				<Spacer height='m' />

				<FlexBox>
					<Value label={label} option={option} optionId={optionId} productId={productId} type={type} isSetupFee />
					<Spacer width='s' />
					<Type option={option} optionId={optionId} productId={productId} type={type} isSetupFee />
				</FlexBox>
				{get(fieldInfo, `${type}.${productId}.${optionId}.setupFee.discount.value.isValid`, true) === false && (
					<ErrorMessage
						errorMessages={get(fieldInfo, `${type}.${productId}.${optionId}.setupFee.discount.value.errorMessages`, [])}
					/>
				)}
			</Dropdown>
			<Spacer height='m' />
		</>
	);
};

Setting.propTypes = {
	label: PropTypes.string.isRequired,
	option: PropTypes.object.isRequired,
	optionId: PropTypes.number.isRequired,
	productId: PropTypes.number.isRequired,
	type: PropTypes.oneOf(['products', 'extensions']).isRequired
};

export default Setting;
